import { combineReducers } from '@reduxjs/toolkit';
import AuthReducer from '../reducers/AuthReducer';
import UserReducer from '../reducers/UserReducer';
import { authQuery } from 'service/authQuery/authQuery';
import { institutionQuery } from 'service/institutionQuery/institutionQuery';
import { candidateQuery } from 'service/candidateQuery/candidateQuery';
import { quizzesQuery } from 'service/quizzesQuery/quizzesQuery';
import { quizAssessmentQuery } from 'service/quizAssessmentQuery/quizAssessmentQuery';
import { uploadQuery } from 'service/uploadQuery/uploadQuery';
import { recruiterQuery } from 'service/recruiterQuery/recruiterQuery';
import { userQuery } from 'service/userQuery/userQuery';

const rootReducer = combineReducers({
  auth: AuthReducer,
  user: UserReducer,
  [authQuery.reducerPath]: authQuery.reducer,
  [institutionQuery.reducerPath]: institutionQuery.reducer,
  [candidateQuery.reducerPath]: candidateQuery.reducer,
  [quizzesQuery.reducerPath]: quizzesQuery.reducer,
  [quizAssessmentQuery.reducerPath]: quizAssessmentQuery.reducer,
  [uploadQuery.reducerPath]: uploadQuery.reducer,
  [recruiterQuery.reducerPath]: recruiterQuery.reducer,
  [userQuery.reducerPath]: userQuery.reducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
